import React,{ useState, useEffect } from 'react';
import styles from './index.module.scss'

const PersonalCenter = (props: any) => {


    useEffect(() => {
        window.document.title = '个人中心'
    }, [])

    return (
        <div className={styles.personalCenter_container}>
            个人中心
        </div>
    )
}

export default PersonalCenter;